export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26')
];

export const server_loads = [];

export const dictionary = {
		"/": [5],
		"/app/account": [6,[2]],
		"/app/dashboard": [7,[2]],
		"/app/data-retention": [8,[2]],
		"/app/forge": [9,[2,3]],
		"/app/forge/parse": [10,[2,3,4]],
		"/app/forge/parse/documents/new": [15,[2,3,4]],
		"/app/forge/parse/documents/[documentId]/configure": [11,[2,3,4]],
		"/app/forge/parse/documents/[documentId]/rulesets": [12,[2,3,4]],
		"/app/forge/parse/documents/[documentId]/rulesets/[rulesetId]": [13,[2,3,4]],
		"/app/forge/parse/documents/[documentId]/view": [14,[2,3,4]],
		"/app/forge/structured-extraction": [16,[2,3]],
		"/app/keys": [17,[2]],
		"/app/pages/[slug]": [18,[2]],
		"/app/playground": [19,[2]],
		"/app/subscription": [20,[2]],
		"/app/usage": [21,[2]],
		"/app/webhooks": [22,[2]],
		"/auth/reset_password": [23],
		"/auth/reset_password/[token]": [24],
		"/auth/sign_in": [25],
		"/auth/sign_up": [26]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';